// =============================================================
// Ảnh/icon PNG lấy nguyên từ mobile-app-v2 để cổng nhân viên (web)
// hiển thị "y hệt" app. Import trực tiếp -> trả về URL để dùng.
// =============================================================

// Nền + tab bar
import background_info from "./home/background_info.png";
import bg_union from "./tab_bar/bg_union.png";
import icon_checkin from "./tab_bar/icon_checkin.png";
import icon_home from "./tab_bar/icon_home.png";
import icon_home_fill from "./tab_bar/icon_home_fill.png";
import icon_tai_chinh from "./tab_bar/icon_tai_chinh.png";
import icon_tai_chinh_fill from "./tab_bar/icon_tai_chinh_fill.png";
import icon_new from "./tab_bar/icon_new.png";
import icon_new_fill from "./tab_bar/icon_new_fill.png";
import icon_account from "./tab_bar/icon_account.png";
import icon_account_fill from "./tab_bar/icon_account_fill.png";

// Icon khối chức năng (home)
import icon_cham_cong from "./home/icon_cham_cong.png";
import icon_dky_cn from "./home/icon_dky_cn.png";
import icon_dk_lam_bu from "./home/icon_dk_lam_bu.png";
import icon_xin_nghi_phep from "./home/icon_xin_nghi_phep.png";
import icon_Du_an from "./home/icon_Du_an.png";
import icon_dot_mo_ban from "./home/icon_dot_mo_ban.png";
import icon_khach_hang from "./home/icon_khach_hang.png";
import icon_booking from "./home/icon_booking.png";
import icon_looking from "./home/icon_looking.png";
import icon_HDMB from "./home/icon_HDMB.png";
import icon_dang_ky_chuen_GD from "./home/icon_dang_ky_chuen_GD.png";
import icon_ctv from "./home/icon_ctv.png";
import icon_Thu_nhap_ca_nhan from "./home/icon_Thu_nhap_ca_nhan.png";
import icon_search from "./home/icon_search.png";
import icon_notification from "./home/icon_notification.png";
import icon_TTKQ from "./icon_TTKQ.png";
import icon_gioi_thieu_viec_lam from "./icon_gioi_thieu_viec_lam.png";

// Tin tức nội bộ (slider) + Quản lý
import bg_slider_tai_lieu from "./home/bg_slider_tai_lieu.png";
import bg_slider_vinh_danh from "./home/bg_slider_vinh_danh.png";
import bg_slider_tin_tuc from "./home/bg_slider_tin_tuc.png";
import icon_QLNV from "./home/icon_QLNV.png";
import icon_QLCC from "./home/icon_QLCC.png";
import icon_QLBH from "./home/icon_QLBH.png";
import icon_BC_Thong_ke from "./home/icon_BC_Thong_ke.png";
import icon_phe_duyet_np from "./home/icon_phe_duyet_np.png";
import icon_phe_duyet_cong_ngoai from "./home/icon_phe_duyet_cong_ngoai.png";
import icon_phieu_dang_ky from "./icon_phieu_dang_ky.png";
import icon_profile from "./icon_profile.png";
import icon_upload_image from "./icon_upload_image.png";
import icon_upload_photo from "./icon_upload_photo.png";
import icon_bin from "./icon_bin.png";
import image_background from "./image_background.png";
import white_logo from "./white_logo.png";
import icon_chevron_right from "./icon_chevron_right.png";
import icon_Cai_dat from "./account/icon_Cai_dat.png";
import icon_DKSD from "./account/icon_DKSD.png";
import icon_HDNV from "./account/icon_HDNV.png";
import icon_logout from "./account/icon_logout.png";
import icon_QL_chu_ky from "./account/icon_QL_chu_ky.png";
import icon_maintenance from "./icon_maintenance.png";
import image_project_example from "./image_project_example.png";
import icon_total_customer from "./icon_total_customer.png";
import icon_customer_personal from "./icon_customer_personal.png";
import icon_customer_business from "./icon_customer_business.png";

// Icon thẻ đánh giá + tiện ích chung
import icon_phone_call from "./icon_phone_call.png";
import icon_circle_dollar_sign from "./icon_circle_dollar_sign.png";
import icon_user_plus from "./icon_user_plus.png";
import empty_avatar from "./empty_avatar.png";
import icon_create from "./icon_create.png";
import icon_filter_detail from "./icon_filter_detail.png";
import icon_chevron_down from "./icon_chevron_down.png";
import icon_chevron_up from "./icon_chevron_up.png";
import icon_chevron_left from "./icon_chevron_left.png";
import ion_sort_desc from "./ion_sort_desc.png";
import icon_check from "./icon_check.png";
import icon_clock from "./icon_clock.png";
import icon_map_pin from "./icon_map_pin.png";
import icon_check_circle from "./icon_check_circle.png";
import icon_reject_circle from "./icon_reject_circle.png";
import icon_close from "./icon_close.png";

// Icon dùng cho các màn Quản lý (lấy nguyên từ mobile-app-v2)
import icon_avatar from "./icon_avatar.png";
import icon_award from "./icon_award.png";
import icon_trending_up from "./icon_trending_up.png";
import icon_triangle_alert from "./icon_triangle_alert.png";
import icon_heart_handshake from "./icon_heart_handshake.png";
import icon_user_check from "./icon_user_check.png";
import icon_building_2 from "./icon_building_2.png";
import icon_giao_dich from "./icon_giao_dich.png";
import icon_giai_ngan from "./icon_giai_ngan.png";
import icon_locking from "./icon_locking.png";
import icon_area from "./icon_area.png";
import icon_du_an from "./icon_du_an.png";
import icon_PDV from "./icon_PDV.png";
import icon_more_vertical from "./icon_more_vertical.png";
import icon_plus from "./icon_plus.png";
import icon_edit_customer from "./icon_edit_customer.png";
import icon_check_in from "./icon_check_in.png";
import icon_filter from "./icon_filter.png";
import icon_detail from "./icon_detail.png";
import icon_gia_niem_yet from "./icon_gia_niem_yet.png";
import icon_total_commission from "./icon_total_commission.png";
import icon_thu_nhap from "./home/icon_thu_nhap.png";

// Icon dùng cho màn Quản lý chữ kí (lấy nguyên từ mobile-app-v2)
import icon_edit from "./icon_edit.png";
import icon_delete_square from "./icon_delete_square.png";

export const appImages = {
  background_info,
  bg_union,
  icon_checkin,
  icon_home,
  icon_home_fill,
  icon_tai_chinh,
  icon_tai_chinh_fill,
  icon_new,
  icon_new_fill,
  icon_account,
  icon_account_fill,
  icon_cham_cong,
  icon_dky_cn,
  icon_dk_lam_bu,
  icon_xin_nghi_phep,
  icon_Du_an,
  icon_dot_mo_ban,
  icon_khach_hang,
  icon_booking,
  icon_looking,
  icon_HDMB,
  icon_dang_ky_chuen_GD,
  icon_ctv,
  icon_Thu_nhap_ca_nhan,
  icon_search,
  icon_notification,
  icon_TTKQ,
  icon_gioi_thieu_viec_lam,
  bg_slider_tai_lieu,
  bg_slider_vinh_danh,
  bg_slider_tin_tuc,
  icon_QLNV,
  icon_QLCC,
  icon_QLBH,
  icon_BC_Thong_ke,
  icon_phe_duyet_np,
  icon_phe_duyet_cong_ngoai,
  icon_phieu_dang_ky,
  icon_profile,
  icon_upload_image,
  icon_upload_photo,
  icon_bin,
  image_background,
  white_logo,
  icon_chevron_right,
  icon_Cai_dat,
  icon_DKSD,
  icon_HDNV,
  icon_logout,
  icon_QL_chu_ky,
  icon_maintenance,
  image_project_example,
  icon_total_customer,
  icon_customer_personal,
  icon_customer_business,
  icon_phone_call,
  icon_circle_dollar_sign,
  icon_user_plus,
  empty_avatar,
  icon_create,
  icon_filter_detail,
  icon_chevron_down,
  icon_chevron_up,
  icon_chevron_left,
  ion_sort_desc,
  icon_check,
  icon_clock,
  icon_map_pin,
  icon_check_circle,
  icon_reject_circle,
  icon_close,
  icon_avatar,
  icon_award,
  icon_trending_up,
  icon_triangle_alert,
  icon_heart_handshake,
  icon_user_check,
  icon_building_2,
  icon_giao_dich,
  icon_giai_ngan,
  icon_locking,
  icon_area,
  icon_du_an,
  icon_PDV,
  icon_more_vertical,
  icon_plus,
  icon_edit_customer,
  icon_check_in,
  icon_filter,
  icon_detail,
  icon_gia_niem_yet,
  icon_total_commission,
  icon_thu_nhap,
  icon_edit,
  icon_delete_square,
};

export default appImages;
